import { Phone, ArrowRight } from "lucide-react";
import { PHONE, PHONE_HREF } from "../../data/site";

const HERO_IMG = "https://images.unsplash.com/photo-1621747084845-4ef34685f942?crop=entropy&cs=srgb&fm=jpg&q=80&w=2000";

export const Hero = () => (
  <section id="top" data-testid="hero-section" className="relative flex min-h-screen items-center overflow-hidden pt-20">
    <img src={HERO_IMG} alt="" className="absolute inset-0 h-full w-full object-cover opacity-35 grayscale" />
    <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/40" />
    <div className="absolute inset-0 grid-lines opacity-40" />
    <div className="relative mx-auto grid w-full max-w-7xl items-center gap-12 px-5 py-20 lg:grid-cols-12 lg:px-8">
      <div className="lg:col-span-7">
        <div className="hero-in flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-[#1E9BFF]">
          <span className="pulse-dot" /> Drainage & Utility Specialists
        </div>
        <h1 data-testid="hero-heading" className="hero-in mt-6 font-display text-5xl font-extrabold uppercase leading-[0.92] sm:text-6xl lg:text-7xl" style={{ animationDelay: "120ms" }}>
          Drainage & Utility Specialists <span className="text-glow text-[#1E9BFF]">You Can Rely On</span>
        </h1>
        <p className="hero-in mt-8 max-w-xl text-base text-neutral-300 md:text-lg" style={{ animationDelay: "240ms" }}>
          From blocked drains and CCTV surveys to new installations, utility ducting and no-dig repairs, Pipe-Line UK gets the job done right first time, for homes and businesses.
        </p>
        <div className="hero-in mt-10 flex flex-col gap-4 sm:flex-row" style={{ animationDelay: "360ms" }}>
          <a href={PHONE_HREF} data-testid="hero-call-button" className="btn-primary justify-center px-8 py-4 text-base">
            <Phone className="h-5 w-5" /> Call Now · {PHONE}
          </a>
          <a href="#contact" data-testid="hero-quote-button" className="btn-outline justify-center px-8 py-4 text-base">
            Request a Quote <ArrowRight className="h-5 w-5" />
          </a>
        </div>
      </div>
      <div className="hero-in relative mx-auto hidden w-full max-w-md lg:col-span-5 lg:block" style={{ animationDelay: "200ms" }}>
        <div className="logo-halo absolute inset-0 rounded-full" />
        <img src="/logo.jpg" alt="Pipe-Line UK" data-testid="hero-logo" className="float relative w-full rounded-full" />
      </div>
    </div>
  </section>
);
